module.exports = __webpack_public_path__ + "img/github-logo.cfff8513.svg";